import { caseStagesQueryOptions } from "@/features/case-record/api/queries/case-stage-query";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import z from "zod";

export const Route = createFileRoute("/_dashboard/settings_/keywords")({
	validateSearch: z.object({
		search: z.string().optional(),
		status: z.string().optional(),
		per_page: z.number().optional(),
		page: z.number().nullable().optional(),
		include: z.string().optional(),
	}),
	preSearchFilters: [
		(search) => ({
			...search,
		}),
	],
	loaderDeps: ({ search }) => ({
		page: search.page,
		per_page: search.per_page,
		search: search.search,
		status: search.status,
	}),
	loader: ({ context: { queryClient }, deps }) => {
		return queryClient.ensureQueryData(
			caseStagesQueryOptions({
				...deps,
				case_classification: null,
			}),
		);
	},
	component: lazyRouteComponent(() => import("@/features/dashboard/pages/settings.keywords.index")),
});
